import { AutogenModelCheckCallSched, AutogenRowCheckCallSched } from "./autogen/AutogenModelCheckCallSched";

export class ModelCheckCallSched extends AutogenModelCheckCallSched<RowCheckCallSched> {
	constructor() {
		super(RowCheckCallSched);
	}
}

export class RowCheckCallSched extends AutogenRowCheckCallSched {
}